import { apiGet, apiPut, apiDelete, apiPost } from "@redriver/cinnamon";

const NAMESPACE = "ADMIN/USER_ACTIONS";

const ActionTypes = {
  GetUser: `${NAMESPACE}/GET_USER`,
  UpdateUser: `${NAMESPACE}/UPDATE_USER`,
  ResendVerification: `${NAMESPACE}/RESEND_VERIFICATION`,
  SendPasswordReset: `${NAMESPACE}/SEND_PASSWORD_RESET`,
  LockOutUser: `${NAMESPACE}/LOCK_OUT_USER`,
  ActivateUser: `${NAMESPACE}/ACTIVATE_USER`,
  UpdateUserMfa: `${NAMESPACE}/UPDATE_USER_MFA_ENABLEMENT`,
  ResetUserMfa: `${NAMESPACE}/RESET_USER_MFA`,
};

export const getUser = (userId) =>
  apiGet(ActionTypes.GetUser, `users/${userId}`);

export const updateUser = (data, userId) => {
  return apiPut(ActionTypes.UpdateUser, `users/${userId}`, data);
};

export const resendVerification = (userId) =>
  apiPost(
    ActionTypes.ResendVerification,
    `users/${userId}/resend-verification-email`
  );

export const sendPasswordReset = (submitParams) => {
  return apiPost(
    ActionTypes.SendPasswordReset,
    `users/send-password-reset-email`,
    submitParams
  );
};

export const updateUserMfa = (submitParams) => {
  return apiPut(
    ActionTypes.UpdateUserMfa,
    `users/mfa-enablement`,
    submitParams
  );
};

export const resetUserMfa = (submitParams) => {
  return apiPost(ActionTypes.ResetUserMfa, `users/reset-mfa`, submitParams);
};
